export var navList = [
    {
        linkName: 'Cases',
        linkPath: '/cases',
        icon: 'cases',
    },
    {
        linkName: 'Clients',
        linkPath: '/clients',
        icon: 'clients',
    },
    {
        linkName: 'Products',
        linkPath: '/products',
        icon: 'products',
    },
];
